'use client';
import { LicenseInfo } from '@mui/x-license';
import { mui_license_key } from './server.config';

LicenseInfo.setLicenseKey(mui_license_key);

export default function MuiXLicense() {
  return null;
}